import Cookies from 'js-cookie';
import axiosConfig from '../../config/axiosConfig';
import { fetchUserBusinesses } from '../../state/actions/loginAction';

const handleUserSignIn = ({ userBusinessList, router }) => {
  localStorage.removeItem('userInfo');
  if (
    Cookies.get('ictl_user') &&
    JSON.parse(Cookies.get('ictl_user')).first_name
  ) {
    if (userBusinessList.length > 0) {
      const activeMerchant = userBusinessList[0];
      localStorage.removeItem('addBusiness');

      router.push(`/business/${activeMerchant.merchant.business_username}`);
    } else {
      localStorage.activeMerchant && localStorage.removeItem('activeMerchant');

      router.push('/business/register');
    }
  } else {
    router.push('/user/info');
  }
};

export const redirectLoggedInUser = ({ router, redirect, dispatch }) => {
  if (redirect) {
    router.replace(redirect);
  } else {
    if (process.env.NEXT_PUBLIC_SOURCE_PACKAGE === 'marketplace') {
      router.replace('/');
    } else {
      fetchUserBusinesses(dispatch).then(userBusinessList => {
        handleUserSignIn({ userBusinessList, router });
      });
    }
  }
};

export const storeAndRedirectUser = ({
  authResponse,
  router,
  redirect,
  dispatch,
}) => {
  localStorage.resetPasswordData &&
    localStorage.removeItem('resetPasswordData');

  const ICTLIFE_USER_TOKEN = authResponse.headers['x-ictlife-token'];
  axiosConfig.defaults.headers['X-ICTLIFE-TOKEN'] = ICTLIFE_USER_TOKEN;
  Cookies.set('ictl_user', JSON.stringify(authResponse.data), {
    expires: 365,
  });
  Cookies.set('ictl_token', ICTLIFE_USER_TOKEN, {
    expires: 365,
  });

  redirectLoggedInUser({
    router,
    redirect,
    dispatch,
  });
};
